var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Big from "big.js";
import { decodeFixedPointType } from "../utils/encoding";
import { currencyIdToMonetaryCurrency } from "../utils";
export var GriefingCollateralType;
(function (GriefingCollateralType) {
    GriefingCollateralType[GriefingCollateralType["Issue"] = 0] = "Issue";
    GriefingCollateralType[GriefingCollateralType["Replace"] = 1] = "Replace";
})(GriefingCollateralType || (GriefingCollateralType = {}));
export class DefaultFeeAPI {
    constructor(api, oracleAPI) {
        this.api = api;
        this.oracleAPI = oracleAPI;
    }
    getGriefingCollateral(amount, type) {
        return __awaiter(this, void 0, void 0, function* () {
            let ratePromise;
            switch (type) {
                case GriefingCollateralType.Issue: {
                    ratePromise = this.getIssueGriefingCollateralRate();
                    break;
                }
                case GriefingCollateralType.Replace: {
                    ratePromise = this.getReplaceGriefingCollateralRate();
                    break;
                }
            }
            const nativeCurrency = yield currencyIdToMonetaryCurrency(this.api, this.api.consts.vaultRegistry.getGriefingCollateralCurrencyId);
            const [griefingCollateralRate, griefingAmount] = yield Promise.all([
                ratePromise,
                this.oracleAPI.convertWrappedToCurrency(amount, nativeCurrency),
            ]);
            return griefingAmount.mul(griefingCollateralRate);
        });
    }
    getIssueGriefingCollateralRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const griefingCollateralRate = yield this.api.query.fee.issueGriefingCollateral();
            return decodeFixedPointType(griefingCollateralRate);
        });
    }
    getReplaceGriefingCollateralRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const griefingCollateralRate = yield this.api.query.fee.replaceGriefingCollateral();
            return decodeFixedPointType(griefingCollateralRate);
        });
    }
    getIssueFee() {
        return __awaiter(this, void 0, void 0, function* () {
            const issueFee = yield this.api.query.fee.issueFee();
            return decodeFixedPointType(issueFee);
        });
    }
    calculateAPY(feesWrapped, lockedCollateral, exchangeRate) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: change back to isZero once monetary fix is released.
            if (lockedCollateral.toBig().eq(0)) {
                return new Big(0);
            }
            if (exchangeRate === undefined) {
                exchangeRate = yield this.oracleAPI.getExchangeRate(lockedCollateral.currency);
            }
            const feesWrappedAsCollateral = exchangeRate.toCounter(feesWrapped).toBig();
            // convert to percentage
            return feesWrappedAsCollateral.div(lockedCollateral.toBig()).mul(100);
        });
    }
}
//# sourceMappingURL=fee.js.map